import styled from "styled-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const BacklinksBodyContainer = styled(FlexColumn)`
    width: 100%;
    padding-bottom: 32px;
    max-width: 1366px;

    div[class*="WidgetHeaderContainer"] {
        height: auto;

        div[class*="WidgetMetadataContainer"] {
            justify-content: center;
        }
    }
`;

export const Truncate = styled.div<{ $lineClap?: number }>`
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: ${({ $lineClap = 2 }) => $lineClap};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
    width: 100%;
    max-width: 100%;
    white-space: normal;
`;
